import {apiInstance} from '../../api';
import {builderDocumentsRoute, builderRoute} from './builder.route';

export class ApiApartmentBuilderService {
  static async fetchBuilders() {
    return apiInstance.get(builderRoute);
  }

  static async createBuilder(formData) {
    return apiInstance.post(builderRoute, formData);
  }

  static async updateBuilder(builderId, formData) {
    return apiInstance.put(`${builderRoute}/${builderId}`, formData);
  }

  static getBuilderFile(builderId) {
    return apiInstance.get(`${builderDocumentsRoute}/${builderId}`)
  }

  static async deleteBuilder(builderId) {
    return apiInstance.delete(`${builderRoute}/${builderId}`);
  }
}
